var _style, _g, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRanking = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 294 278.8",
    style: {
      enableBackground: "new 0 0 294 278.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF153C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.5,120.9H23.9c-5,0-9,4-9,9v94.2c0,5,4,9,9,9h37.6c5,0,9-4,9-9v-94.2C70.5,124.9,66.4,120.9,61.5,120.9z  M52.5,215.1H32.9v-76.2h19.6V215.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.2,71H94.6c-5,0-9,4-9,9v144c0,5,4,9,9,9h37.6c5,0,9-4,9-9V80C141.2,75.1,137.2,71,132.2,71z M123.2,215.1 h-19.6V89h19.6C123.2,89,123.2,215.1,123.2,215.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203,128.3h-37.6c-5,0-9,4-9,9v86.7c0,5,4,9,9,9H203c5,0,9-4,9-9v-86.7C212,132.3,208,128.3,203,128.3z  M194,215.1h-19.6v-68.7H194V215.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.8,74.4h-37.6c-5,0-9,4-9,9v140.7c0,5,4,9,9,9h37.6c5,0,9-4,9-9V83.4C282.8,78.4,278.7,74.4,273.8,74.4z  M264.8,215.1h-19.6V92.4h19.6L264.8,215.1L264.8,215.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.9,90.6c3.3,2.4,7.7,2.3,10.9-0.2l67.3-53.7l-0.3,8.8c-0.2,5,3.7,9.1,8.7,9.3c0.1,0,0.2,0,0.3,0 c4.8,0,8.8-3.8,9-8.7l1.1-31.5c0.1-2.5-0.9-4.9-2.6-6.7c-1.8-1.8-4.2-2.7-6.7-2.6l-31.5,1.1c-5,0.2-8.9,4.3-8.7,9.3 c0.2,5,4.3,8.8,9.3,8.7l8.3-0.3L184,72l-68.2-49.6c-3-2.2-7-2.3-10.1-0.3L4.2,86.6C0,89.2-1.3,94.8,1.4,99c1.7,2.7,4.6,4.2,7.6,4.2 c1.6,0,3.3-0.5,4.8-1.4l96.3-61.1L178.9,90.6z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 128.3,
    className: "st0",
    width: 37.4,
    height: 95.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5,
    y: 76.8,
    className: "st0",
    width: 44,
    height: 151.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 133.8,
    className: "st0",
    width: 46.9,
    height: 94
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 232.5,
    y: 80.8,
    className: "st0",
    width: 46,
    height: 143
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9,
    y: 252.8,
    className: "st0",
    width: 267.9,
    height: 11
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRanking, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ranking.47e2d35e.svg";
export { ForwardRef as ReactComponent };